import { PropTypes } from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';

import { vehicleTypes, fuelPolicies, transmissionTypes } from 'constants/carHire';

export const carHireOptionPropType = ImmutablePropTypes.mapContains({
  name: PropTypes.string.isRequired,
  imageUrl: PropTypes.string.isRequired,
  pricing: ImmutablePropTypes.mapContains({
    webPrice: PropTypes.number,
  }),
  vehicleType: PropTypes.oneOf(Object.values(vehicleTypes)),
  seats: PropTypes.number,
  bags: PropTypes.number,
  doors: PropTypes.number,
  airConditioning: PropTypes.bool,
  transmission: PropTypes.oneOf(Object.values(transmissionTypes)),
  fuelPolicy: PropTypes.oneOf(Object.values(fuelPolicies)),
});



/** WEBPACK FOOTER **
 ** ./src/components/CarHire/shapes.js
 **/